import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from '../../TelaCarregando'; 

function ProcessoSeletivo_Externo() {
  const [step, setStep] = useState(1); 
  const navigate = useNavigate();
  const stepTracked = useRef(0);

  const [formData, setFormData] = useState({
    vaga_selecionada: '',
    nome_completo: '',
    nascimento_dia: '', 
    nascimento_mes: '',
    nascimento_ano: '',
    cpf: '',
    celular: '',
    email: '',
    cep: '',
    regioes_disponiveis: [] 
  });

  const [vagasAtivas, setVagasAtivas] = useState([]); 
  const [isLoadingVagas, setIsLoadingVagas] = useState(true); 

  const [isLoading, setIsLoading] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false); 
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // LGPD: aceite obrigatório do Aviso de Privacidade antes de enviar dados pessoais.
  const [aceiteLgpd, setAceiteLgpd] = useState(false);
  const [showAvisoPrivacidade, setShowAvisoPrivacidade] = useState(false);

  const listaCidades = ['Vitória', 'Vila Velha', 'Serra', 'Cariacica', 'Guarapari'];

  // --- GERADORES DE DATA PARA OS SELECTS ---
  const dias = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));
  const meses = [
      { val: '01', nome: 'Janeiro' }, { val: '02', nome: 'Fevereiro' }, { val: '03', nome: 'Março' },
      { val: '04', nome: 'Abril' }, { val: '05', nome: 'Maio' }, { val: '06', nome: 'Junho' },
      { val: '07', nome: 'Julho' }, { val: '08', nome: 'Agosto' }, { val: '09', nome: 'Setembro' },
      { val: '10', nome: 'Outubro' }, { val: '11', nome: 'Novembro' }, { val: '12', nome: 'Dezembro' }
  ];
  const anoAtual = new Date().getFullYear();
  const anos = Array.from({ length: 67 }, (_, i) => String(anoAtual - 13 - i)); 

  // ==========================================
  // CORREÇÃO: RASTREAMENTO DINÂMICO
  // ==========================================
  useEffect(() => {
    // 1. Trava de Segurança: Não rastreia se estiver preso no iframe do Canva, 
    // pois a página vai recarregar sozinha logo a seguir.
    if (window.self !== window.top) return;

    // 2. Trava de Memória: Evita que o React dispare 2 vezes o mesmo passo
    if (stepTracked.current === step) return;
    stepTracked.current = step; // Grava que este passo já foi rastreado
    
    const tipoPagina = step === 1 ? 'VAGAS' : 'INSCRICAO';
    
    fetch('/api/processo-seletivo/rastrear-acesso', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tipo_pagina: tipoPagina })
    }).catch(err => console.log("Erro silencioso no tracker:", err)); 
    
  }, [step]);

  // ==========================================
  // BUSCA DE VAGAS
  // ==========================================
  useEffect(() => {
    const carregarVagas = async () => {
      const startTime = Date.now(); 
      const tempoMinimoAnimacao = 2000; 

      try {
        const response = await fetch('/api/processo-seletivo/vagas-ativas');
        if (!response.ok) throw new Error("Falha ao carregar as vagas");
        
        let data = await response.json();

        // 👇 ORDENAÇÃO ALFABÉTICA ADICIONADA AQUI 👇
        data.sort((a, b) => a.CARGO.localeCompare(b.CARGO));

        setVagasAtivas(data);

        const elapsedTime = Date.now() - startTime;

        if (elapsedTime < tempoMinimoAnimacao) {
          setTimeout(() => { setIsLoadingVagas(false); }, tempoMinimoAnimacao - elapsedTime);
        } else {
          setIsLoadingVagas(false);
        }
      } catch (err) {
        console.error(err);
        setIsLoadingVagas(false);
      }
    };
    
    carregarVagas();
  }, []);

  useEffect(() => {
    if (window.self !== window.top) {
      window.top.location.href = window.location.href;
    }
  }, []);
  
  const validarCPF = (cpfInput) => {
    const cpfTratado = cpfInput.replace(/[^\d]+/g, ''); 
    if (cpfTratado.length !== 11 || /^(\d)\1+$/.test(cpfTratado)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpfTratado.charAt(i)) * (10 - i);
    let restoDv1 = soma % 11;
    let dv1 = restoDv1 >= 2 ? 11 - restoDv1 : 0;
    if (dv1 !== parseInt(cpfTratado.charAt(9))) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpfTratado.charAt(i)) * (11 - i);
    let restoDv2 = soma % 11;
    let dv2 = restoDv2 >= 2 ? 11 - restoDv2 : 0;
    if (dv2 !== parseInt(cpfTratado.charAt(10))) return false;
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRegiaoChange = (cidade) => {
    setFormData((prev) => {
      const novasRegioes = prev.regioes_disponiveis.includes(cidade)
        ? prev.regioes_disponiveis.filter(r => r !== cidade) 
        : [...prev.regioes_disponiveis, cidade]; 
      return { ...prev, regioes_disponiveis: novasRegioes };
    });
  };

  const selecionarVaga = (tituloVaga) => {
    setIsTransitioning(true); 
    setTimeout(() => {
      setFormData((prev) => ({ ...prev, vaga_selecionada: tituloVaga }));
      setStep(2); 
      window.scrollTo(0, 0); 
      setIsTransitioning(false); 
    }, 1500); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validarCPF(formData.cpf)) {
      setError('O CPF digitado é inválido. Por favor, verifique e tente novamente.');
      return; 
    }

    if (formData.regioes_disponiveis.length === 0) {
      setError('Por favor, selecione ao menos uma região de disponibilidade para trabalhar.');
      return;
    }

    if (!aceiteLgpd) {
      setError('Para finalizar, é necessário ler e aceitar o Aviso de Privacidade.');
      return;
    }

    // --- VALIDAÇÃO DE DATA DE NASCIMENTO ---
    const dataFormatada = `${formData.nascimento_ano}-${formData.nascimento_mes}-${formData.nascimento_dia}`;
    // Verifica se a data é real (ex: barra 31 de Fevereiro)
    const dateVerificacao = new Date(`${dataFormatada}T12:00:00`);
    if (dateVerificacao.getMonth() + 1 !== parseInt(formData.nascimento_mes)) {
        setError('A data de nascimento selecionada é inválida. Por favor, verifique o dia e o mês.');
        return;
    }

    setIsLoading(true);

    try {
      const response = await fetch('/api/processo-seletivo/etapa1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          data_nascimento: dataFormatada, // Manda para o Back-end no formato que ele já espera
          regioes_disponiveis: formData.regioes_disponiveis.join(', '),
          data_inscricao: new Date().toISOString(),
          consentimento_lgpd: true,       // LGPD: aceite do Aviso de Privacidade
          consentimento_versao: 'v1'      // versão do termo aceito (o backend grava a data)
        }),
      });
      
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Erro ao submeter os dados.');

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontSize: '14px', backgroundColor: '#f8fafc', color: '#334155', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '6px' };
  const cardStyle = { backgroundColor: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };

  if (isLoadingVagas || isTransitioning) {
    return <LoadingScreen />;
  }

  if (success) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f8fafc', padding: '20px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div style={{ backgroundColor: '#fff', maxWidth: '600px', width: '100%', padding: '40px 24px', borderRadius: '24px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)', textAlign: 'center', animation: 'fadeInUp 0.5s ease-out' }}>
        <div style={{ width: '80px', height: '80px', backgroundColor: '#dcfce7', color: '#16a34a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '40px', margin: '0 auto 24px auto' }}>✓</div>
        <h2 style={{ fontSize: '28px', fontWeight: '800', color: '#0f172a', marginBottom: '16px' }}>Inscrição Recebida!</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
          <p style={{ fontSize: '16px', color: '#475569', margin: 0, lineHeight: '1.5' }}>Agradecemos o seu interesse em fazer parte da equipe do <strong>Grupo Correia</strong>.</p>
          <p style={{ fontSize: '16px', color: '#475569', margin: 0, lineHeight: '1.5' }}>Recebemos seu cadastro e nossa equipe irá analisá-lo com atenção.</p>
          <p style={{ fontSize: '15px', color: '#1e293b', margin: '8px 0 0 0', lineHeight: '1.6', backgroundColor: '#f1f5f9', padding: '15px', borderRadius: '12px', borderLeft: '4px solid #16a34a' }}>
            <strong>Fique atento:</strong> Se seu perfil for selecionado, entraremos em contato pelo <strong>WhatsApp</strong> para os próximos passos.
          </p>
        </div>
        <button onClick={() => navigate('/vagas')} style={{ width: '100%', padding: '14px', fontSize: '16px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '700', transition: 'all 0.2s', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1e293b'} onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0f172a'}>
          Voltar para o Início
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img alt="Logotipo Grupo Correia" src="/icon-logotipo.png" style={{ height: '150px', objectFit: 'contain' }} />
        </div>

        {step === 1 && (
          <div style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <h1 style={{ fontSize: '28px', fontWeight: '900', color: '#0f172a', margin: '0 0 8px 0' }}>Vagas Abertas</h1>
              <p style={{ color: '#64748b', fontSize: '16px', margin: 0 }}>Selecione a oportunidade que mais combina com você para iniciar sua inscrição.</p>
            </div>

            {vagasAtivas.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                    <h3 style={{ color: '#0f172a' }}>Nenhuma vaga aberta no momento.</h3>
                    <p style={{ color: '#64748b' }}>Fique de olho, em breve teremos novas oportunidades!</p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {vagasAtivas.map((vaga) => (
                    <div key={vaga.ID} style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px', borderBottom: '1px solid #f1f5f9', paddingBottom: '16px', marginBottom: '16px' }}>
                        <div>
                        <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#0f172a', margin: '0 0 8px 0' }}>{vaga.CARGO}</h2>
                        <span style={{ display: 'inline-block', backgroundColor: '#ecfdf5', color: '#10b981', padding: '6px 12px', borderRadius: '8px', fontWeight: '800', fontSize: '14px' }}>
                            💰 Salário: {vaga.SALARIO}
                        </span>
                        </div>
                        <button 
                        onClick={() => selecionarVaga(vaga.CARGO)}
                        style={{ backgroundColor: '#e11d1d', color: '#fff', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 2px 4px rgba(225,29,29,0.2)' }}
                        >
                        Selecionar Vaga
                        </button>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
                        <div>
                        <h4 style={{ fontSize: '14px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>📝 Requisitos & Rotina</h4>
                        <ul style={{ fontSize: '14px', color: '#334155', margin: '0 0 8px 0',listStyleType: 'none',padding: 0 }}><strong>Perfil:</strong> 
                            {vaga.REQUISITOS && vaga.REQUISITOS.split('\n').map((req, idx) => (
                                req.trim() !== '' && <li key={idx}>{req}</li>
                            )) }
                        </ul>
                        <p style={{ fontSize: '14px', color: '#334155', margin: '0 0 8px 0' }}><strong>Escalas:</strong> {vaga.ESCALAS}</p>
                        <p style={{ fontSize: '14px', color: '#334155', margin: 0 }}><strong>Turnos:</strong> {vaga.TURNOS}</p>
                        </div>
                        
                        <div>
                        <h4 style={{ fontSize: '14px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>🎁 Benefícios</h4>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px', color: '#334155', lineHeight: '1.6' }}>
                            {vaga.BENEFICIOS && vaga.BENEFICIOS.split('\n').map((ben, idx) => (
                                ben.trim() !== '' && <li key={idx}>{ben}</li>
                            ))}
                        </ul>
                        </div>
                    </div>

                    </div>
                ))}
                </div>
            )}
          </div>
        )}

        {step === 2 && (
          <div style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
            
            <button 
              onClick={() => setStep(1)}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'transparent', border: 'none', color: '#64748b', fontWeight: '700', cursor: 'pointer', marginBottom: '24px', padding: 0 }}
            >
              ← Voltar para Vagas
            </button>

            <div style={{ backgroundColor: '#fff', borderLeft: '4px solid #FDBB20', padding: '20px', borderRadius: '8px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                <div>
                  <p style={{ fontSize: '13px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', margin: '0 0 4px 0' }}>Você está se candidatando para:</p>
                  <h2 style={{ fontSize: '20px', fontWeight: '900', color: '#0f172a', margin: 0 }}>{formData.vaga_selecionada}</h2>
                </div>
            </div>

            {error && (
                <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: '16px', borderRadius: '8px', marginBottom: '24px', fontWeight: '600' }}>
                    {error}
                </div>
            )}

            <form onSubmit={handleSubmit}>
              
              <div style={cardStyle}>
                <h3 style={{ fontSize: '16px', fontWeight: '800', color: '#0f172a', marginBottom: '20px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>Dados Pessoais</h3>
                
                <div style={{ marginBottom: '16px' }}>
                    <label style={labelStyle}>Nome Completo</label>
                    <input type="text" name="nome_completo" value={formData.nome_completo} onChange={handleChange} style={inputStyle} placeholder="Digite seu nome completo" required />
                </div>
                
                <div style={{ marginBottom: '16px' }}>
                    <label style={labelStyle}>CPF</label>
                    <input type="text" name="cpf" value={formData.cpf} onChange={handleChange} style={inputStyle} placeholder="Apenas números" maxLength="14" required />
                </div>

                {/* --- NOVO BLOCO: DATA DE NASCIMENTO EM 3 PASSOS --- */}
                <div style={{ marginBottom: '16px' }}>
                    <label style={labelStyle}>Data de Nascimento</label>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '10px' }}>
                        <select name="nascimento_dia" value={formData.nascimento_dia} onChange={handleChange} style={inputStyle} required>
                            <option value="">Dia</option>
                            {dias.map(d => <option key={d} value={d}>{d}</option>)}
                        </select>
                        
                        <select name="nascimento_mes" value={formData.nascimento_mes} onChange={handleChange} style={inputStyle} required>
                            <option value="">Mês</option>
                            {meses.map(m => <option key={m.val} value={m.val}>{m.nome}</option>)}
                        </select>
                        
                        <select name="nascimento_ano" value={formData.nascimento_ano} onChange={handleChange} style={inputStyle} required>
                            <option value="">Ano</option>
                            {anos.map(a => <option key={a} value={a}>{a}</option>)}
                        </select>
                    </div>
                </div>

              </div>

              <div style={cardStyle}>
                <h3 style={{ fontSize: '16px', fontWeight: '800', color: '#0f172a', marginBottom: '20px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>Informações de Contato</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '16px' }}>
                    <div>
                        <label style={labelStyle}>Celular (WhatsApp)</label>
                        <input type="tel" name="celular" value={formData.celular} onChange={handleChange} style={inputStyle} placeholder="(DD) 9XXXX-XXXX" required />
                    </div>
                    <div>
                        <label style={labelStyle}>CEP</label>
                        <input type="text" name="cep" value={formData.cep} onChange={handleChange} style={inputStyle} placeholder="Apenas números" maxLength="9" required />
                    </div>
                </div>
                <div>
                    <label style={labelStyle}>E-mail</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} placeholder="exemplo@email.com" required />
                </div>
              </div>

              <div style={cardStyle}>
                <h3 style={{ fontSize: '16px', fontWeight: '800', color: '#0f172a', marginBottom: '20px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>Disponibilidade de Região</h3>
                <label style={{...labelStyle, marginBottom: '12px'}}>Em quais cidades você tem disponibilidade para trabalhar? (Selecione uma ou mais)</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px' }}>
                    {listaCidades.map(cidade => (
                        <label key={cidade} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', color: '#334155', fontWeight: '500', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: formData.regioes_disponiveis.includes(cidade) ? '#fef2f2' : '#fff', transition: 'all 0.2s' }}>
                            <input type="checkbox" checked={formData.regioes_disponiveis.includes(cidade)} onChange={() => handleRegiaoChange(cidade)} style={{ width: '18px', height: '18px', accentColor: '#e11d1d', cursor: 'pointer' }} />
                            {cidade}
                        </label>
                    ))}
                </div>
              </div>

              {/* LGPD: aceite obrigatório do Aviso de Privacidade (destaque + trava o envio) */}
              <div style={{ ...cardStyle, borderLeft: `4px solid ${aceiteLgpd ? '#16a34a' : '#e11d1d'}`, transition: 'border-color 0.2s' }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', cursor: 'pointer', fontSize: '14px', color: '#334155', lineHeight: '1.5' }}>
                  <input
                    type="checkbox"
                    checked={aceiteLgpd}
                    onChange={(e) => setAceiteLgpd(e.target.checked)}
                    style={{ width: '20px', height: '20px', accentColor: '#16a34a', cursor: 'pointer', marginTop: '1px', flexShrink: 0 }}
                  />
                  <span>
                    <strong>Li e concordo</strong> com o tratamento dos meus dados pessoais conforme o{' '}
                    <button
                      type="button"
                      onClick={() => setShowAvisoPrivacidade(true)}
                      style={{ background: 'none', border: 'none', padding: 0, color: '#e11d1d', fontWeight: '700', textDecoration: 'underline', cursor: 'pointer', fontSize: '14px' }}
                    >
                      Aviso de Privacidade
                    </button>.
                  </span>
                </label>
                {!aceiteLgpd && (
                  <p style={{ margin: '10px 0 0 32px', fontSize: '12px', color: '#e11d1d', fontWeight: 600 }}>
                    ⚠️ É necessário aceitar para finalizar a inscrição.
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={isLoading || !aceiteLgpd}
                style={{ width: '100%', padding: '16px', backgroundColor: (isLoading || !aceiteLgpd) ? '#94a3b8' : '#e11d1d', color: '#fff', fontSize: '16px', fontWeight: '800', border: 'none', borderRadius: '8px', cursor: (isLoading || !aceiteLgpd) ? 'not-allowed' : 'pointer', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', transition: 'background-color 0.2s' }}
              >
                {isLoading ? 'Enviando Inscrição...' : 'Finalizar Inscrição'}
              </button>

            </form>

            {/* Modal do Aviso de Privacidade.
                ⚠️ TEXTO PROVISÓRIO — a redação final é de RH/jurídico. O mecanismo
                (checkbox + gravação de data/versão) não depende deste texto; trocar a
                string quando o jurídico aprovar e subir a versão ('v1' → 'v2'...). */}
            {showAvisoPrivacidade && (
              <div
                onClick={() => setShowAvisoPrivacidade(false)}
                style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999, padding: '20px' }}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{ backgroundColor: '#fff', borderRadius: '20px', maxWidth: '640px', width: '100%', maxHeight: '85vh', overflowY: 'auto', padding: '32px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)' }}
                >
                  <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#0f172a', marginTop: 0, marginBottom: '16px' }}>Aviso de Privacidade</h2>
                  <div style={{ fontSize: '14px', color: '#334155', lineHeight: '1.7' }}>
                    <p><strong>Controlador:</strong> Grupo Correia MC. Dúvidas e solicitações sobre seus dados: fale com o setor de Recrutamento e Seleção.</p>
                    <p><strong>Quais dados coletamos:</strong> nome completo, CPF, data de nascimento, telefone/WhatsApp, e-mail, CEP e regiões de disponibilidade.</p>
                    <p><strong>Para que usamos:</strong> avaliar sua candidatura às vagas do Grupo Correia e dar andamento ao processo seletivo (contato, agendamento de entrevista e exames, contratação).</p>
                    <p><strong>Base legal:</strong> execução de diligências preliminares relacionadas a contrato, a seu pedido (art. 7º, V, da LGPD).</p>
                    <p><strong>Compartilhamento:</strong> usamos a plataforma ManyChat para contato via WhatsApp; seus dados de contato podem ser tratados por esse serviço para essa finalidade.</p>
                    <p><strong>Por quanto tempo guardamos:</strong> pelo período do processo seletivo e por prazo adicional para eventuais novas oportunidades, conforme nossa política de retenção.</p>
                    <p><strong>Seus direitos:</strong> você pode solicitar acesso, correção, exclusão ou portabilidade dos seus dados, e revogar este consentimento, a qualquer momento, pelo canal de Recrutamento e Seleção.</p>
                  </div>
                  <div style={{ display: 'flex', gap: '12px', marginTop: '24px', flexWrap: 'wrap' }}>
                    <button
                      type="button"
                      onClick={() => setShowAvisoPrivacidade(false)}
                      style={{ flex: '1 1 140px', padding: '14px', backgroundColor: '#fff', color: '#475569', fontSize: '15px', fontWeight: '700', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer' }}
                    >
                      Fechar
                    </button>
                    <button
                      type="button"
                      onClick={() => { setAceiteLgpd(true); setShowAvisoPrivacidade(false); }}
                      style={{ flex: '1 1 140px', padding: '14px', backgroundColor: '#16a34a', color: '#fff', fontSize: '15px', fontWeight: '800', border: 'none', borderRadius: '10px', cursor: 'pointer' }}
                    >
                      Li e concordo
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProcessoSeletivo_Externo;